export default [
    '#880000',
    '#008800',
    '#553300',
    '#000088',
    '#770077',
    '#007777',
    '#888888',
    '#00FF00',
    '#EEEE00',
    '#0000FF',
    '#EE00EE',
    '#00EEEE'
]
